module.exports = __webpack_public_path__ + "static/reward-bg.1d589b0a.png";